module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-nav', {
    staticClass: "primary-nav nav-fill"
  }, [_c('b-nav-item', [_vm._v(" About\n      "), _c('b-nav', {
    staticClass: "secondary-nav",
    attrs: {
      "vertical": ""
    }
  }, [_c('b-nav-item', {
    attrs: {
      "to": {
        name: 'history'
      }
    }
  }, [_vm._v("History")]), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "to": {
        name: 'aimsAndScope'
      }
    }
  }, [_vm._v("Aims & Scope")]), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "to": {
        name: 'announcements'
      }
    }
  }, [_vm._v("News")]), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "to": {
        name: 'sponsorshipRequest'
      }
    }
  }, [_vm._v("Conference Sponsorship")])], 1)], 1), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "to": {
        name: 'contact'
      }
    }
  }, [_vm._v("Contact "), _c('div', {
    staticClass: "icon icon-color-arrow-right-dark"
  })]), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "to": {
        name: 'careers'
      }
    }
  }, [_vm._v("Careers "), _c('div', {
    staticClass: "icon icon-color-arrow-right-dark"
  })])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a1eb09a4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main-layout/footer-area/navigation/FooterNavigationComponent.vue
// module id = 1466
// module chunks = 1